import { render } from "./RejectForm.vue?vue&type=template&id=4d579adf"
import script from "./RejectForm.vue?vue&type=script&lang=js"
export * from "./RejectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__